import { render, staticRenderFns } from "./removeInvoice.vue?vue&type=template&id=f9ce3800&scoped=true"
import script from "./removeInvoice.vue?vue&type=script&lang=ts"
export * from "./removeInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ce3800",
  null
  
)

export default component.exports